import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/comics', label: '漫画合集' },
  { to: '/about', label: '关于我们' },
  { to: '/faq', label: '常见问题' },
  { to: '/contact', label: '联系我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-emotion-laugh-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-950 whitespace-nowrap">
            歪歪漫画
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  active
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-800 hover:bg-primary-100/60 hover:text-primary-700'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/comics"
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-accent-500 text-background-50 px-5 py-2 text-sm font-medium transition-colors hover:bg-accent-600 whitespace-nowrap"
          >
            <i className="ri-sparkling-2-line"></i>
            开始追更
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-900 md:hidden"
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md px-4 py-3">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => {
              const active = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`rounded-lg px-4 py-3 text-sm font-medium whitespace-nowrap ${
                    active ? 'bg-primary-500 text-background-50' : 'text-foreground-800 hover:bg-primary-100/60'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        </div>
      )}
    </header>
  );
}